import { render } from "./StoreSkeleton.vue?vue&type=template&id=4e8dac0f"
import script from "./StoreSkeleton.vue?vue&type=script&lang=js"
export * from "./StoreSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__